import globalConfig from 'Helper/configHelpers'
const {heap_id: heapId } = globalConfig

function auth(state = {}, action) {
  let newState
  switch (action.type) {
    case 'STORE_CONFIG_READ_ALL':
    case 'STORE_CONFIG_SEARCH':
      newState = { ...state }
      action.result.forEach(config => {
        if (config.name === 'inactivityTimeoutMins') {
          newState.inactivity_timeout = config.value
        }
      })
      return newState
    case 'STORE_CONFIG_READ':
    case 'STORE_CONFIG_UPDATE':
    case 'STORE_CONFIG_CREATE':
      newState = { ...state }
      if (action.result.name === 'inactivityTimeoutMins') {
        newState.inactivity_timeout = action.result.value
      }
      return newState
    case 'SET_API_FAIL_COUNT':
      return {
        ...state,
        API_FAIL_COUNT: action.value
      }
    case 'xtract-auth@set-ad-domains':
      newState = {
        ...state
      }
      if (action.domains != null && Array.isArray(action.domains)) {
        newState.ad_domains = action.domains
      }
      return newState
    case 'STORE_ME_READ_ALL':
    case 'STORE_ME_UPDATE':
      newState = {
        ...state,
        username: action.result.displayname,
        user_id: action.result.user_id,
        privilege: action.result.privileges,
        auth_provider: action.result.auth_provider
      }
      if(heapId) {
        heap.identify(action.result.user_id);
        heap.addUserProperties({
          user_Id: action.result.user_id,
          first_Name: action.result.firstname,
          last_Name: action.result.lastname,
          display_Name: action.result.displayname,
          privilege: action.result.privileges
        });
      }
      return newState
    case 'xtract-auth@attempt-login':
      return {
        ...state,
        acknowledgedAlerts: []
      }
    case 'xtract-auth@auth-call-end':
      newState = {
        ...state,
        authCallInProgress: false
      }
      return newState
    case 'xtract-auth@set-token':
      newState = {
        ...state,
        authCallInProgress: false,
        token: action.token,
        refreshTimer: action.refreshTimer,
        refreshToken: action.refreshToken
      }
      return newState
    case 'xtract-auth@get-auth-code-token':
      return {
        ...state,
        authCallInProgress: true
      }
    case 'xtract-auth@clear-token':
      return {
        ...state,
        token: null
      }
    case 'xtract-auth@end-token-refresh': // when token is returned
      return {
        ...state,
        refreshInProgress: false,
        refreshTimer: action.refreshTimer,
        token: action.token,
        refreshToken: action.refreshToken,
        API_FAIL_COUNT: 0
      }
    case 'xtract-auth@cancel-token-refresh':
      return {
        ...state,
        refreshInProgress: false
      }
    case 'xtract-auth@start-token-refresh':
      return {
        ...state,
        refreshInProgress: true
      }
    case 'xtract-auth@store-refresher-handle':
      return {
        ...state,
        refresherHandles: [...state.refresherHandles.filter(task => task.isRunning && task.isRunning()), action.handle]
      }
    case 'xtract-auth@clear-refresher-handles':
      return {
        ...state,
        refresherHandles: []
      }
    case 'xtract-auth@reducer-logout':
      if (action.csrf_token) {
        // if it was a successful logout the session was destroyed and a new csrf was generated so update the one in the page
        // incase another user logsin without reloading.
        if(heapId) {
          heap.resetIdentity();
        }
        globalConfig.setCsrfToken(action.csrf_token)
      }

      return {
        ...state,
        refreshTimer: null,
        refreshToken: null,
        refreshInProgress: false,
        token: null,
        privilege: null,
        acknowledgedAlerts: [],
        loggedOut: true
      }
    default:
      return state
  }
}

export default auth
